import { getApiConfig } from "../authHelper"

import { get, put } from "../api_helper"
import * as url from "../url_helper"

export const getAllFirms = (userId) => {
  return get(`${url.FIRM}?userId=${userId}`, getApiConfig())
}

export const restoreFirm = (firmId) => {
  return put(`${url.FIRM}/restore/${firmId}`, {}, getApiConfig())
}
